/** Base theme color **/
const baseThemeColor = {
  // Primary
  primary180: '#5A0C0C',
  primary160: '#7E1111',
  primary140: '#971717',
  primary120: '#B81E1E',
  primary100: '#D42525',
  primary80: '#E14C4C',
  primary60: '#EA7575',
  primary40: '#F2A1A1',
  primary20: '#FAD6D6',
  primary10: '#FDEDED',
  primary5: '#FEF6F6',

  // Primary alpha
  primaryAlpha90: 'rgba(212, 37, 37, 0.90)',
  primaryAlpha80: 'rgba(212, 37, 37, 0.80)',
  primaryAlpha70: 'rgba(212, 37, 37, 0.70)',
  primaryAlpha60: 'rgba(212, 37, 37, 0.60)',
  primaryAlpha50: 'rgba(212, 37, 37, 0.50)',
  primaryAlpha40: 'rgba(212, 37, 37, 0.40)',
  primaryAlpha30: 'rgba(212, 37, 37, 0.30)',
  primaryAlpha20: 'rgba(212, 37, 37, 0.20)',
  primaryAlpha10: 'rgba(212, 37, 37, 0.10)',
  primaryAlpha5: 'rgba(212, 37, 37, 0.05)',
  primaryAlpha0: 'rgba(212, 37, 37, 0)',

  // Neutral
  neutral900: '#0A0D14',
  neutral200: '#21262D',
  neutral180: '#313A44',
  neutral160: '#434E5B',
  neutral140: '#5A6877',
  neutral120: '#6D7D8D',
  neutral100: '#8594A3',
  neutral80: '#A1ADB9',
  neutral70: '#5E6C84',
  neutral60: '#B8C1CC',
  neutral50: '#D5D7E1',
  neutral40: '#D2D8DF',
  neutral20: '#E3E7ED',
  neutral10: '#F2F4F7',
  neutral5: '#F9FAFB',
  neutral0: '#FFFFFF',

  // Neutral Bg
  neutralBg10: '#F2F4F7',
  neutralBg0: '#FFFFFF',

  // White
  white100: '#FFFFFF',
  white90: 'rgba(255, 255, 255, 0.9)',
  white80: 'rgba(255, 255, 255, 0.8)',
  white70: 'rgba(255, 255, 255, 0.7)',
  white60: 'rgba(255, 255, 255, 0.6)',
  white50: 'rgba(255, 255, 255, 0.5)',
  white40: 'rgba(255, 255, 255, 0.4)',
  white30: 'rgba(255, 255, 255, 0.3)',
  white20: 'rgba(255, 255, 255, 0.2)',
  white10: 'rgba(255, 255, 255, 0.1)',
  white5: 'rgba(255, 255, 255, 0.05)',
  white0: 'rgba(255, 255, 255, 0)',

  // Yellow
  yellowReadable: '#DD7800', // Using yellow120 instead
  yellow180: '#8F4E00',
  yellow160: '#A75B00',
  yellow140: '#BF6800',
  yellow120: '#DD7800',
  yellow100: '#FF991F',
  yellow80: '#FFAD4C',
  yellow60: '#FFC279',
  yellow40: '#FFD6A5',
  yellow20: '#FFEBD2',
  yellow10: '#FFF5E9',
  yellow5: '#FFFAF4',

  // Green
  green180: '#1D3A23',
  green160: '#244C2C',
  green140: '#2E6639',
  green120: '#347F43',
  green100: '#329546',
  green80: '#4AB05E',
  green60: '#6CC67E',
  green40: '#96D9A3',
  green20: '#CAECD1',
  green10: '#ECF9EE',
  green5: '#F3FBF5',

  // Red
  red180: '#67210A',
  red160: '#872B0D',
  red140: '#AB3812',
  red120: '#C64115',
  red100: '#E24B19',
  red80: '#EC6C41',
  red60: '#F19374',
  red40: '#F7B7A1',
  red20: '#FBDAD0',
  red10: '#FEF0EC',
  red5: '#FEF8F5',

  // Neutral alpha
  neutralAlpha100: '#21262D',
  neutralAlpha90: 'rgba(33, 38, 45, 0.90)',
  neutralAlpha80: 'rgba(27, 43, 67, 0.80)',
  neutralAlpha70: 'rgba(27, 43, 67, 0.70)',
  neutralAlpha60: 'rgba(27, 43, 67, 0.60)',
  neutralAlpha50: 'rgba(27, 43, 67, 0.50)',
  neutralAlpha40: 'rgba(27, 43, 67, 0.40)',
  neutralAlpha30: 'rgba(27, 43, 67, 0.30)',
  neutralAlpha20: 'rgba(27, 43, 67, 0.20)',
  neutralAlpha10: 'rgba(27, 43, 67, 0.10)',
  neutralAlpha5: 'rgba(27, 43, 67, 0.05)',
  neutralAlpha0: 'rgba(32, 46, 67, 0)',

  // Neutral Inverse Alpha
  neutralInverseAlpha100: '#FFFFFF',
  neutralInverseAlpha90: 'rgba(255, 255, 255, 0.9)',
  neutralInverseAlpha80: 'rgba(255, 255, 255, 0.8)',
  neutralInverseAlpha70: 'rgba(255, 255, 255, 0.7)',
  neutralInverseAlpha60: 'rgba(255, 255, 255, 0.6)',
  neutralInverseAlpha50: 'rgba(255, 255, 255, 0.5)',
  neutralInverseAlpha40: 'rgba(255, 255, 255, 0.4)',
  neutralInverseAlpha30: 'rgba(255, 255, 255, 0.3)',
  neutralInverseAlpha20: 'rgba(255, 255, 255, 0.2)',
  neutralInverseAlpha10: 'rgba(255, 255, 255, 0.1)',
  neutralInverseAlpha5: 'rgba(255, 255, 255, 0.05)',
  neutralInverseAlpha0: 'rgba(255, 255, 255, 0)',

  // Neutral dark
  neutralDark180: '#313A44',
  neutralDark160: '#434E5B',
  neutralDark140: '#5A6877',
  neutralDark120: '#6D7D8D',
  neutralDark100: '#8594A3',

  // Neutral dark alpha
  neutralDarkAlpha100: '#21262D',
  neutralDarkAlpha90: 'rgba(33, 38, 45, 0.9)',
  neutralDarkAlpha80: 'rgba(33, 38, 45, 0.8)',
  neutralDarkAlpha70: 'rgba(33, 38, 45, 0.7)',
  neutralDarkAlpha60: 'rgba(33, 38, 45, 0.6)',
  neutralDarkAlpha50: 'rgba(33, 38, 45, 0.5)',
  neutralDarkAlpha40: 'rgba(33, 38, 45, 0.4)',
  neutralDarkAlpha30: 'rgba(33, 38, 45, 0.3)',
  neutralDarkAlpha20: 'rgba(33, 38, 45, 0.2)',
  neutralDarkAlpha10: 'rgba(33, 38, 45, 0.1)',
  neutralDarkAlpha5: 'rgba(33, 38, 45, 0.05)',
  neutralDarkAlpha0: 'rgba(33, 38, 45, 0)',

  // Blue
  blue180: '#0F2657',
  blue160: '#143171',
  blue140: '#1B4193',
  blue120: '#1547B2',
  blue100: '#2B52D4',
  blue80: '#5480DE',
  blue60: '#7D9FE8',
  blue40: '#A7BFF1',
  blue20: '#CAD8F7',
  blue10: '#EDF2FD',
  blue5: '#F6F8FE',

  // Purple
  purple180: '#211056',
  purple160: '#2C1773',
  purple140: '#3D209D',
  purple120: '#4927B9',
  purple100: '#5B37D2',
  purple80: '#7A5CDB',
  purple60: '#9880E5',
  purple40: '#BAA9EF',
  purple20: '#D5CBF6',
  purple10: '#F1EDFC',
  purple5: '#F8F6FE',

  // Pink
  pink180: '#61222E',
  pink160: '#893041',
  pink140: '#A83A50',
  pink120: '#C2435C',
  pink100: '#D94B67',
  pink80: '#E66B80',
  pink60: '#EB95A2',
  pink40: '#F0B5BD',
  pink20: '#F5D1D6',
  pink10: '#FAE9EB',
  pink5: '#FCF3F4',

  // Cabaret
  cabaret160: '#98381B',
  cabaret140: '#AE3F1E',
  cabaret120: '#C54B26',
  cabaret100: '#E25328',
  cabaret80: '#F16237',
  cabaret60: '#F37D59',
  cabaret40: '#F89577',
  cabaret20: '#FEDCD2',
  cabaret10: '#FEECE7',
  cabaret5: '#FFF7F5',

  // Deepsky
  deepsky160: '#0E6987',
  deepsky140: '#137DA0',
  deepsky120: '#1B91B8',
  deepsky100: '#27A3CD',
  deepsky80: '#38B4DD',
  deepsky60: '#50C3E9',
  deepsky40: '#70D2F2',
  deepsky20: '#98E0F9',
  deepsky10: '#DCF5FE',
  deepsky5: '#F5FCFF',

  // Wave Blue
  waveBlue60: '#0077A3',
  waveBlue50: '#169CCD',
  waveBlue40: '#1CB4E0',
  waveBlue30: '#3DCBF5',
  waveBlue20: '#A2E0F9',
  waveBlue10: '#CFEDFB',
  waveBlue5: '#EBF9FF',

  // Navy Blue
  navyBlue60: '#035381',
  navyBlue50: '#0670AE',
  navyBlue40: '#0C93D6',
  navyBlue30: '#0DA6F2',
  navyBlue20: '#88CCF6',
  navyBlue10: '#D6F1FF',
  navyBlue5: '#F0F9FF',

  // Leaderboard
  // TODO: Need Implement

  // Light Grey
  lightGrey180: '#CCD9E1',
  lightGrey160: '#D4DFE6',
  lightGrey140: '#DCE5EA',
  lightGrey120: '#E6ECF0',
  lightGrey100: '#F3F6F8',
  lightGrey80: '#F5F8F9',
  lightGrey60: '#F8FAFB',
  lightGrey40: '#FAFBFC',
  lightGrey20: '#FDFDFE',
  lightGrey10: '#FEFEFE',
  lightGrey5: '#FEFFFF',

  // Black Alpha
  blackAlpha100: '#000000',
  blackAlpha90: 'rgba(0, 0, 0, 0.90)',
  blackAlpha80: 'rgba(0, 0, 0, 0.80)',
  blackAlpha70: 'rgba(0, 0, 0, 0.70)',
  blackAlpha60: 'rgba(0, 0, 0, 0.60)',
  blackAlpha50: 'rgba(0, 0, 0, 0.50)',
  blackAlpha40: 'rgba(0, 0, 0, 0.40)',
  blackAlpha30: 'rgba(0, 0, 0, 0.30)',
  blackAlpha20: 'rgba(0, 0, 0, 0.20)',
  blackAlpha10: 'rgba(0, 0, 0, 0.10)',
  blackAlpha5: 'rgba(0, 0, 0, 0.05)',

  // Golden
  // TODO: Need Implement

  // Lemon
  // TODO: Need Implement

  // Magenta
  // TODO: Need Implement

  // Paper
  paper180: '#8F5717',
  paper160: '#965B19',
  paper140: '#AA661E',
  paper120: '#CC7926',
  paper100: '#DC934E',
  paper80: '#ECB073',
  paper60: '#F7CC9C',
  paper40: '#FCE1BF',
  paper20: '#FEEFDA',
  paper10: '#FFF6EB',
  paper5: '#FFF9F1',

  // Paper Alpha
  // TODO: Need Implement

  // Blue alpha
  blueAlpha100: '#2B52D4',
  blueAlpha90: 'rgba(43, 82, 212, 0.90)',
  blueAlpha80: 'rgba(43, 82, 212, 0.80)',
  blueAlpha70: 'rgba(43, 82, 212, 0.70)',
  blueAlpha60: 'rgba(43, 82, 212, 0.60)',
  blueAlpha50: 'rgba(43, 82, 212, 0.50)',
  blueAlpha40: 'rgba(43, 82, 212, 0.40)',
  blueAlpha30: 'rgba(43, 82, 212, 0.30)',
  blueAlpha20: 'rgba(43, 82, 212, 0.20)',
  blueAlpha10: 'rgba(43, 82, 212, 0.10)',
  blueAlpha5: 'rgba(43, 82, 212, 0.05)',
  blueAlpha0: 'rgba(43, 82, 212, 0)',

  // Wave Blue Alpha
  // TODO: Need Implement

  // Green alpha
  greenAlpha100: '#329546',
  greenAlpha90: 'rgba(50, 149, 70, 0.90)',
  greenAlpha80: 'rgba(50, 149, 70, 0.80)',
  greenAlpha70: 'rgba(50, 149, 70, 0.70)',
  greenAlpha60: 'rgba(50, 149, 70, 0.60)',
  greenAlpha50: 'rgba(50, 149, 70, 0.50)',
  greenAlpha40: 'rgba(50, 149, 70, 0.40)',
  greenAlpha30: 'rgba(50, 149, 70, 0.30)',
  greenAlpha20: 'rgba(50, 149, 70, 0.20)',
  greenAlpha10: 'rgba(50, 149, 70, 0.10)',
  greenAlpha5: 'rgba(50, 149, 70, 0.05)',
  greenAlpha0: 'rgba(50, 149, 70, 0)',

  // Red alpha
  redAlpha100: '#E24B19',
  redAlpha90: 'rgba(226, 75, 25, 0.90)',
  redAlpha80: 'rgba(226, 75, 25, 0.80)',
  redAlpha70: 'rgba(226, 75, 25, 0.70)',
  redAlpha60: 'rgba(226, 75, 25, 0.60)',
  redAlpha50: 'rgba(226, 75, 25, 0.50)',
  redAlpha40: 'rgba(226, 75, 25, 0.40)',
  redAlpha30: 'rgba(226, 75, 25, 0.30)',
  redAlpha20: 'rgba(226, 75, 25, 0.20)',
  redAlpha10: 'rgba(226, 75, 25, 0.10)',
  redAlpha5: 'rgba(226, 75, 25, 0.05)',
  redAlpha0: 'rgba(226, 75, 25, 0)',

  // Yellow alpha
  // TODO: Need Implement

  // Black
  black100: '#242938',
  black90: '#373C4B',
  black80: '#505460',
  black70: '#6F727B',
  black60: '#7C7F88',
  black50: '#95979F',
  black40: '#A7A9AF',
  black30: '#BDBEC3',
  black20: '#D3D4D7',
  black10: '#E9EAEB',
  black5: '#F4F4F5',

  // Brand
  // TODO: Need Implement

  // Brand Amazon
  // TODO: Need Implement
};

/** General color system **/
const generalColorSystem = {
  // Bg Color Body
  bgColorBodyNeutralPrimary: baseThemeColor.neutralBg0,
  bgColorBodyNeutralSecondary: baseThemeColor.neutralBg10,
  bgColorBodyNeutralInversePrimary: baseThemeColor.neutral180,
  bgColorBodyNeutralInverseDim: baseThemeColor.neutral160,
  bgColorBodyNeutralPriDashboard: baseThemeColor.neutralBg0,
  bgColorBodyNeutralDim: baseThemeColor.neutral10,
  bgColorBodyNeutralSubtle: baseThemeColor.neutral5,

  // Bg Color Ele
  bgColorEleNeutralPrimary: baseThemeColor.neutral0,
  bgColorEleNeutralSubtle: baseThemeColor.neutral5,
  bgColorEleNeutralDim: baseThemeColor.neutral10,
  bgColorEleNeutralDeep: baseThemeColor.neutral20,
  bgColorEleNeutralStress: baseThemeColor.neutral40,
  bgColorEleNeutralInversePrimary: baseThemeColor.neutral180,
  bgColorEleNeutralInverseDim: baseThemeColor.neutral160,
  bgColorEleNeutralIDarkPrimary: baseThemeColor.neutralDark180,
  bgColorEleBrandPrimary: baseThemeColor.primary100,
  bgColorEleBrandSecondary: baseThemeColor.primary40,
  bgColorEleBrandDim: baseThemeColor.primary10,

  // Text Color
  textColorNeutralStress: baseThemeColor.neutral200,
  textColorNeutralPrimary: baseThemeColor.neutral180,
  textColorNeutralSubtle: baseThemeColor.neutral140,
  textColorNeutralSecondary: baseThemeColor.neutral120,
  textColorNeutralDim: baseThemeColor.neutral100,
  textColorNeutralDisable: baseThemeColor.neutral80,
  textColorNeutralReversePrimary: baseThemeColor.neutral0,
  textColorWhitePrimary: baseThemeColor.white100,
  textColorWhiteSecondary: baseThemeColor.white70,
  textColorBrandPrimary: baseThemeColor.primary100,
  textColorBrandSecondary: baseThemeColor.primary60,
  textColorInfoPrimary: baseThemeColor.blue100,
  textColorInfoSecondary: baseThemeColor.blue80,
  textColorSuccessPrimary: baseThemeColor.green100,
  textColorSuccessSecondary: baseThemeColor.green80,
  textColorWarningPrimary: baseThemeColor.yellow120,
  textColorWarningSecondary: baseThemeColor.yellow100,
  textColorErrorPrimary: baseThemeColor.red100,
  textColorErrorSecondary: baseThemeColor.red80,
  textColorSubBrandPrimary: baseThemeColor.purple100,
  textColorSubBrandSecondary: baseThemeColor.purple80,

  // Icon Color
  iconColorNeutralStress: baseThemeColor.neutral200,
  iconColorNeutralPrimary: baseThemeColor.neutral180,
  iconColorNeutralSubtle: baseThemeColor.neutral140,
  iconColorNeutralSecondary: baseThemeColor.neutral100,
  iconColorNeutralDim: baseThemeColor.neutral80,
  iconColorNeutralDisable: baseThemeColor.neutral60,
  iconColorNeutralReversePrimary: baseThemeColor.neutral0,
  iconColorWhitePrimary: baseThemeColor.white90,
  iconColorWhiteSecondary: baseThemeColor.white60,
  iconColorBrandPrimary: baseThemeColor.primary100,
  iconColorBrandSecondary: baseThemeColor.primary60,
  iconColorInfoPrimary: baseThemeColor.blue100,
  iconColorInfoSecondary: baseThemeColor.blue80,
  iconColorSuccessPrimary: baseThemeColor.green100,
  iconColorSuccessSecondary: baseThemeColor.green60,
  iconColorWarningPrimary: baseThemeColor.yellow100,
  iconColorWarningSecondary: baseThemeColor.yellow80,
  iconColorErrorPrimary: baseThemeColor.red100,
  iconColorErrorSecondary: baseThemeColor.red80,
  iconColorSubBrandPrimary: baseThemeColor.purple100,
  iconColorSubBrandSecondary: baseThemeColor.purple80,

  // AI Feature
  aiFeatureAIBorderBox: baseThemeColor.waveBlue40,
  aiFeatureAITextBtn: baseThemeColor.waveBlue60,
  aiFeatureAITextDeep: baseThemeColor.waveBlue60,
  aiFeatureAITextPrimary: baseThemeColor.waveBlue50,
  aiFeatureAIColorIconSub: baseThemeColor.waveBlue40,
  aiFeatureAIColorIconPrimary: baseThemeColor.waveBlue50,

  // Border Color
  borderColorNeutralStress: baseThemeColor.neutral140,
  borderColorNeutralHighlight: baseThemeColor.neutral80,
  borderColorNeutralDeep: baseThemeColor.neutral40,
  borderColorNeutralPrimary: baseThemeColor.neutral20,
  borderColorNeutralSubtle: baseThemeColor.neutral10,
  borderColorNeutralDisable: baseThemeColor.neutral10,
  borderColorNeutralInverse: baseThemeColor.neutral0,
  borderColorWhitePrimary: baseThemeColor.white100,
  borderColorWhiteSecondary: baseThemeColor.white60,
  borderColorBrandHighlight: baseThemeColor.primary100,
  borderColorBrandSecondary: baseThemeColor.primary40,
  borderColorSuccessPrimary: baseThemeColor.green100,
  borderColorSuccessSecondary: baseThemeColor.green40,
  borderColorSuccessDim: baseThemeColor.green20,
  borderColorWarningPrimary: baseThemeColor.yellow100,
  borderColorWarningSecondary: baseThemeColor.yellow60,
  borderColorWarningDim: baseThemeColor.yellow40,
  borderColorErrorPrimary: baseThemeColor.red100,
  borderColorErrorSecondary: baseThemeColor.red40,
  borderColorErrorDim: baseThemeColor.red20,
  borderColorInfoPrimary: baseThemeColor.blue100,
  borderColorInfoSecondary: baseThemeColor.blue40,
  borderColorInfoDim: baseThemeColor.blue20,

  // Table Color
  tableColorCellLine: baseThemeColor.neutral10,
  tableColorHeaderLine: baseThemeColor.neutral20,
  tableColorTableBorder: baseThemeColor.neutral20,
  tableColorRowColorSecondary: baseThemeColor.neutral5,
  tableColorRowColorPrimary: baseThemeColor.neutral0,
  tableColorRowColorHover: baseThemeColor.neutral10,

  /*
   * Do not delete this comment - keep it at bottom
   *
   * Should always add prefix to each property to know which group we use
   * -> E.g. Text color will be textColorNeutralStress instead of neutralStress
   *
   * Important Note: Be careful not override baseThemeColor property
   *
   * */
};

/** Base component token **/
const baseComponentToken = {
  // Input Color Outline Color
  inputColorOutlineColorInputOutlineBorderDefault: generalColorSystem.borderColorNeutralPrimary,
  inputColorOutlineColorInputOutlineBorderHover: generalColorSystem.borderColorNeutralDeep,
  inputColorOutlineColorInputOutlineBorderDisable: generalColorSystem.borderColorNeutralDisable,
  inputColorOutlineColorInputOutlineBgDefault: baseThemeColor.neutral0,
  inputColorOutlineColorInputOutlineBgHover: baseThemeColor.neutral5,
  inputColorOutlineColorInputOutlineBgDisable: baseThemeColor.neutral0,

  // Input Color Bg Color
  inputColorBgColorInputBgDefault: baseThemeColor.neutral10,
  inputColorBgColorInputBgHover: baseThemeColor.neutral20,
  inputColorBgColorInputBgFocus: baseThemeColor.neutral10,
  inputColorBgColorInputBgError: baseThemeColor.neutral10,
  inputColorBgColorInputBgDisable: baseThemeColor.neutral5,
  inputColorBgColorInputBgSelectedDefault: baseThemeColor.blue10,
  inputColorBgColorInputBgSelectedHover: baseThemeColor.blue20,
  inputColorBgColorInputBgSelectedFocus: baseThemeColor.blue10,

  // Input Color Text Color
  inputColorTextColorInputTextPlaceHolder: generalColorSystem.textColorNeutralSecondary,
  inputColorTextColorInputTextFilled: generalColorSystem.textColorNeutralPrimary,
  inputColorTextColorInputTextDisable: generalColorSystem.textColorNeutralDisable,
  inputColorTextColorInputTextFilledDisable: generalColorSystem.textColorNeutralDim,

  // Input Color Border Color
  inputColorBorderColorInputBorderFocus: baseThemeColor.blue80,
  inputColorBorderColorInputBorderError: baseThemeColor.red80,
  inputColorBorderColorInputBorderSuccess: baseThemeColor.green80,
  inputColorBorderColorInputBorderWarning: baseThemeColor.yellow100,
  inputColorBorderColorInputBorderDisable: baseThemeColor.neutral20,

  /*
   * Do not delete this comment - keep it at bottom
   *
   * Should always add prefix to each property to know which group we use
   * -> E.g. Input Color Bg Color will be inputColorBgColorInputBgDefault instead of inputBgDefault
   *
   * Important Note: Be careful not override baseThemeColor property
   *
   * */
};

export const colorsV2 = {
  /** Base theme color **/
  ...baseThemeColor,

  /** General color system **/
  ...generalColorSystem,

  /** Base component token **/
  ...baseComponentToken,

  /*
   *
   * These color below is old term or not grouped or custom from dev
   * Should not use if not necessary
   *
   * Important Note: Be careful not override property from other color object above
   *
   * */
  /* ========================================START======================================== */

  // Black shadow (Dev custom)
  blackShadow1: 'rgba(0, 0, 0, 0.01)',
  blackShadow2: 'rgba(0, 0, 0, 0.02)',
  blackShadow3: 'rgba(0, 0, 0, 0.03)',
  blackShadow4: 'rgba(0, 0, 0, 0.04)',
  blackShadow5: 'rgba(0, 0, 0, 0.05)',
  blackShadow6: 'rgba(0, 0, 0, 0.06)',
  blackShadow7: 'rgba(0, 0, 0, 0.07)',
  blackShadow8: 'rgba(0, 0, 0, 0.08)',

  // Grey (Old term)
  grey200: '#21262D',
  grey180: '#313A44',
  grey160: '#434E5B',
  grey140: '#5A6877',
  grey120: '#6D7D8D',
  grey100: '#8594A3',
  grey80: '#A1ADB9',
  grey70: '#5E6C84',
  grey60: '#B8C1CC',
  grey50: '#D5D7E1',
  grey40: '#D2D8DF',
  grey20: '#E3E7ED',
  grey10: '#F2F4F7',
  grey5: '#F9FAFB',

  // Gray (Old term)
  gray180: '#313A44',
  gray160: '#434E5B',
  gray140: '#5A6877',
  gray120: '#6D7D8D',
  gray100: '#8594A3',
  gray80: '#A1ADB9',
  gray70: '#5E6C84',
  gray60: '#B8C1CC',
  gray50: '#D5D7E1',
  gray40: '#D2D8DF',
  gray20: '#E3E7ED',
  gray10: '#F2F4F7',
  gray5: '#F9FAFB',

  // Light Gray (Old term)
  lightGray180: '#CCD9E1',
  lightGray160: '#D4DFE6',
  lightGray140: '#DCE5EA',
  lightGray120: '#E3EAEF',
  lightGray100: '#F3F6F8',
  lightGray80: '#F3F6F8',
  lightGray60: '#F5F8F9',
  lightGray40: '#F8FAFB',
  lightGray20: '#FDFDFE',
  lightGray10: '#FCFCFD',
  lightGray5: '#FEFFFF',

  // Black transparent (BT) -> To be replaced with Black Alpha instead
  bt10: 'rgba(0, 0, 0, 0.1)',
  bt20: 'rgba(0, 0, 0, 0.2)',
  bt30: 'rgba(0, 0, 0, 0.3)',
  bt40: 'rgba(0, 0, 0, 0.4)',
  bt50: 'rgba(0, 0, 0, 0.5)',
  bt60: 'rgba(0, 0, 0, 0.6)',
  bt70: 'rgba(0, 0, 0, 0.7)',

  // Black transparent (Black Alpha) -> To be replaced with Black Alpha instead
  blackTransparent100: '#000000',
  blackTransparent90: 'rgba(0, 0, 0, 0.90)',
  blackTransparent80: 'rgba(0, 0, 0, 0.80)',
  blackTransparent70: 'rgba(0, 0, 0, 0.70)',
  blackTransparent60: 'rgba(0, 0, 0, 0.60)',
  blackTransparent50: 'rgba(0, 0, 0, 0.50)',
  blackTransparent40: 'rgba(0, 0, 0, 0.40)',
  blackTransparent30: 'rgba(0, 0, 0, 0.30)',
  blackTransparent20: 'rgba(0, 0, 0, 0.20)',
  blackTransparent10: 'rgba(0, 0, 0, 0.10)',
  blackTransparent5: 'rgba(0, 0, 0, 0.05)',

  // Neutral transparent (Not grouped)
  neutralTransparent100: '#313A44',
  neutralTransparent90: 'rgba(52, 65, 80, 0.90)',
  neutralTransparent80: 'rgba(42, 57, 72, 0.80)',
  neutralTransparent70: 'rgba(45, 62, 81, 0.70)',
  neutralTransparent60: 'rgba(50, 69, 90, 0.60)',
  neutralTransparent50: 'rgba(39, 59, 82, 0.50)',
  neutralTransparent40: 'rgba(69, 92, 118, 0.40)',
  neutralTransparent30: 'rgba(117, 141, 168, 0.30)',
  neutralTransparent20: 'rgba(103, 131, 163, 0.20)',
  neutralTransparent10: 'rgba(110, 138, 168, 0.10)',
  neutralTransparent5: 'rgba(115, 138, 163, 0.05)',

  // Gradient (Not grouped)
  gradientGreen: `linear-gradient(90deg, ${baseThemeColor.green100} 0%, ${baseThemeColor.green80} 100%)`,
  gradientBlue: 'linear-gradient(90deg, #2A7CD9 0%, #329EED 99.95%)',
  gradientRed: 'linear-gradient(95deg, #d42525 18.07%, #eb6464 81.04%)',
  gradientRed28To82: 'linear-gradient(297deg, #df5757 28.26%, #f18989 82.75%)',
  gradientWhite013_6To90:
    'linear-gradient(93deg, rgba(255, 255, 255, 0.13) 6.01%, rgba(255, 255, 255, 0.25) 90.83%)',
  gradientWhite021_6To90:
    'linear-gradient(93deg, rgba(255, 255, 255, 0.21) 6.01%, rgba(255, 255, 255, 0.39) 90.83%)',
  gradientPositive: `linear-gradient(270deg, ${baseThemeColor.green100} 0%, ${baseThemeColor.green80} 100%)`,
  gradientWarning: `linear-gradient(270deg, ${baseThemeColor.yellow100} 0%, ${baseThemeColor.yellow80} 100%)`,
  gradientNegative: `linear-gradient(90deg, ${baseThemeColor.red80} 0%, ${baseThemeColor.red100} 100%)`,
  gradientAiGeneralMatteStyleLinear1: `linear-gradient(90deg, ${baseThemeColor.navyBlue10} 0%, ${baseThemeColor.waveBlue5} 100%)`,

  // Overlay Drawer (Not grouped)
  overlayDrawer70: 'rgba(45, 62, 81, 0.7)',

  // Custom colors (Not grouped)
  rgbaGray01: 'rgba(163, 182, 205, 0.60)',
  rgbaGray02: 'rgba(59, 84, 111, 0.14)',

  neutralPrimary: '#313A44',
  neutralSecondary: '#6D7D8D',
  neutralDim: '#8594A3',
  neutralSubtle: '#5A6877',
  neutralStress: '#21262D',
  brandPrimary: '#D42525',
  infoPrimary: '#2B52D4',
  warningPrimary: '#FF991F',

  newYear2: '#FED624',
  newYear5: '#ED6602',

  aiFeatureDeep: '#0077A3',
  aiColorIconPrimary: '#169CCD',
  navyBlueNB05: '#F0F9FF',
  accent100: '#EF692F',

  satLightYellow: '#FEFADA',
  satDarkYellow: '#F8DC4A',
  satLightPink: '#FBE6F7',
  satDarkPink: '#EA9DDA',
  satLightBlue: '#E9F4FE',
  satDarkBlue: '#9ECBF6',

  textColorNeutralSecondary: '#6D7D8D',
  textColorTitleRegular: '#313A44',

  /* ========================================END======================================== */
};
